export function notificationId(type, record) {
  return `${type}:${record?.id || ''}`;
}

export function buildDashboardNotifications(signups = [], transactions = []) {
  const applications = signups.map((signup) => ({
    id: notificationId('application', signup),
    type: 'application',
    title: 'New application received',
    name: signup.fullName || `${signup.firstName || ''} ${signup.lastName || ''}`.trim() || 'A prospective student',
    detail: signup.courseName || 'New course signup',
    date: signup.createdAt,
    recordId: signup.id,
  }));
  const payments = transactions
    .filter((transaction) => transaction.category === 'school_fee' || transaction.type === 'payment')
    .map((transaction) => ({
      id: notificationId('payment', transaction),
      type: 'payment',
      title: 'Fee payment received',
      name: transaction.studentName || transaction.studentEmail || 'A student',
      detail: `${transaction.currency || 'KES'} ${Number(transaction.amount || 0).toLocaleString('en-KE')} · ${transaction.courseName || 'School fees'}`,
      date: transaction.paymentDate || transaction.createdAt,
      recordId: transaction.id,
    }));
  return [...applications, ...payments].sort((a, b) => {
    const aTime = a.date?.toMillis?.() || new Date(a.date || 0).getTime() || 0;
    const bTime = b.date?.toMillis?.() || new Date(b.date || 0).getTime() || 0;
    return bTime - aTime;
  });
}
